import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CustomerSummaryComponent } from './customer-summary';
import { CustomerDetailComponent } from './customer-detail';
import { CustomerAddComponent } from './customer-add';
import { CustomerEditComponent } from './customer-edit';
import { Authguard } from '../../../helper';
import { Roles } from '../../../model';


const routes: Routes = [
  { path: '', redirectTo: 'summary', pathMatch: 'full' },
  {
    path: '',
    data: {
      title: 'Customer'
    },
    children: [
      {
        path: 'summary',
        component: CustomerSummaryComponent,
        data: { title: 'Summary' }
      },
      {
        path: 'detail/:id',
        component: CustomerDetailComponent,
        data: { title: 'Details' }
      },
      {
        path: 'edit/:id',
        component: CustomerEditComponent,
        canActivate: [ Authguard ],
        data: {
          title: 'Edit' ,
          permission: {
            role: [Roles.Admin],
            redirectTo: '403'
          }
        }
      },
      {
        path: 'add',
        component: CustomerAddComponent,
        data: { title: 'Add' }
      },
      {
        path: 'add/:id',
        component: CustomerAddComponent,
        data: { title: 'Add' }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CustomerRoutingModule {}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/customer/customer-routing.module.ts